import React, { useCallback } from 'react';
import { useProviderHelpers } from './ProviderHelpers';

const Context = React.createContext();

export const RoyaltyPlanTemplateProvider = ({ children }) => {
    const { data, execute, clearData } = useProviderHelpers();

    const selectRecord = useCallback(async (props) => {
        await execute({ scope: 'select', url: `RoyaltyPlanTemplate/${props.royaltyPlanId}`, method: 'GET', secure: true });
    }, [execute]);

    const newRecord = useCallback(async (props) => {
        await execute({ scope: 'new', payload: { status: 200, body: props } });
    }, [execute]);

    const createRecord = useCallback(async (props) => {
        await execute({ scope: 'create', url: `RoyaltyPlanTemplate`, method: 'POST', payload: props, secure: true });
    }, [execute]);

    const updateRecord = useCallback(async (props) => {
        await execute({ scope: 'update', url: `RoyaltyPlanTemplate/${props.royaltyPlanId}`, method: 'PUT', payload: props, secure: true });
    }, [execute]);
    
    const listRecords = useCallback(async (_props) => {
        await execute({ scope: 'list', url: `RoyaltyPlanTemplate`, method: 'GET', secure: true });
    }, [execute]);  

    const deleteRecord = useCallback(async (props) => {
        await execute({ scope: 'delete', url: `RoyaltyPlanTemplate/${props.royaltyPlanId}`, method: 'DELETE', secure: true });
    }, [execute]);

    const duplicateRecord = useCallback(async (props) => {
        await execute({ scope: 'duplicate', url: `RoyaltyPlanTemplate/${props.royaltyPlanId}/Duplicate`, method: 'POST', payload: props, secure: true });
    }, [execute]);

    const value = { selectRecord, listRecords, newRecord, deleteRecord, updateRecord, createRecord, duplicateRecord, data, clearData };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useRoyaltyPlanTemplateStore = () => React.useContext(Context);
